module.exports = __webpack_public_path__ + "static/logo-jgprolock-new-1f539234702686b2d83112b3e95770e0.png";